import { useEffect, useState } from "react";
import { Smartphone, Share, PlusSquare } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

const isStandalone = () => window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
const isIOS = () => /iphone|ipad|ipod/i.test(window.navigator.userAgent);

export const InstallApp = () => {
  const [prompt, setPrompt] = useState(null);
  const [help, setHelp] = useState(false);
  const [installed, setInstalled] = useState(isStandalone());

  useEffect(() => {
    const onPrompt = (e) => { e.preventDefault(); setPrompt(e); };
    const onInstalled = () => setInstalled(true);
    window.addEventListener("beforeinstallprompt", onPrompt);
    window.addEventListener("appinstalled", onInstalled);
    return () => { window.removeEventListener("beforeinstallprompt", onPrompt); window.removeEventListener("appinstalled", onInstalled); };
  }, []);

  if (installed) return null;
  const install = async () => {
    if (!prompt) { setHelp(true); return; }
    prompt.prompt();
    const { outcome } = await prompt.userChoice;
    if (outcome === "accepted") setInstalled(true);
    setPrompt(null);
  };

  return (
    <>
      <button data-testid="install-app-button" onClick={install}
        className="mt-3 flex w-full items-center gap-2 rounded-lg bg-white/5 px-3 py-2 text-sm text-slate-200 transition-colors hover:bg-white/10 hover:text-white">
        <Smartphone size={16} /> Instalar app en el celular
      </button>
      <Dialog open={help} onOpenChange={setHelp}>
        <DialogContent className="admin-shell max-w-sm" data-testid="install-help-dialog">
          <DialogHeader>
            <DialogTitle>Instalar Safe Payments</DialogTitle>
            <DialogDescription>Abre este panel desde tu celular y sigue estos pasos.</DialogDescription>
          </DialogHeader>
          <div className="space-y-4 text-sm text-slate-700">
            <div>
              <p className="font-semibold text-slate-900">iPhone (Safari)</p>
              <p className="mt-1 flex items-center gap-1.5">1. Toca <Share size={15} /> Compartir</p>
              <p className="mt-1 flex items-center gap-1.5">2. Elige <PlusSquare size={15} /> Agregar a inicio</p>
            </div>
            <div>
              <p className="font-semibold text-slate-900">Android (Chrome)</p>
              <p className="mt-1">Toca el menú ⋮ y elige "Instalar app" o "Agregar a la pantalla principal".</p>
            </div>
            {isIOS() && <p className="rounded-lg bg-amber-50 p-3 text-xs text-amber-900">En iPhone la instalación solo funciona desde Safari.</p>}
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
